import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { fadeUp } from '../hooks/useAnimations'
import './StateCarousel.css'

export default function StateCarousel({ prevSlug, nextSlug, prevName, nextName }) {
  return (
    <motion.nav
      className="state-carousel"
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1 }}
      aria-label="Navigate between states"
    >
      {prevSlug ? (
        <Link to={`/states/${prevSlug}`} className="state-carousel-link state-carousel-link--prev">
          <span className="state-carousel-arrow">←</span>
          <span className="state-carousel-label">{prevName}</span>
        </Link>
      ) : (
        <span className="state-carousel-spacer" />
      )}

      <Link to="/" className="state-carousel-index">
        All States
      </Link>

      {nextSlug ? (
        <Link to={`/states/${nextSlug}`} className="state-carousel-link state-carousel-link--next">
          <span className="state-carousel-label">{nextName}</span>
          <span className="state-carousel-arrow">→</span>
        </Link>
      ) : (
        <span className="state-carousel-spacer" />
      )}
    </motion.nav>
  )
}
